// App name: GENERAL PURPOSE
// Description: Header, menu, panel

const GeneralApp = (function ($) {

    // variables
    let _body = $('body');
    let _window = $(window);
    let _header = $('.header');
    let _panel = $('#panel-menu');
    let miniCart = $('.cart-nav__mini-cart');

    // init
    function init() {
        _initOpenPanel();
        _initOpenSocials();

        $(window).on('scroll', function () {
            _initResizeHeader();
        });

        _initRelatedProducts();

        if (miniCart.length > 0) {
            initMiniCart();
        }

        _initProductCategoriesIcon();
    }

    function initMiniCart() {
        _body.on('click', '.cart-nav__url:nth-child(2), .cart-nav__mini-cart--close', function (e) {
            e.preventDefault();

            miniCart.toggleClass('active');
        })
    }

    function _initOpenPanel() {
        _body.on('click', '.header__hamburger, .panel-menu__close, .panel-menu__social-button', function (e) {
            e.preventDefault();

            _body.toggleClass('has-open-panel');
            _panel.toggleClass('is-active');

            if ($(this).hasClass('panel-menu__social-map')) {
                $('.socials__map-icon').trigger('click');
            }

            if ($(this).hasClass('panel-menu__social-media')) {
                $('.socials__media').trigger('click');
            }
        })
    };

    function _initOpenSocials() {
        _body.on('click', '.socials__logo', function (e) {
            e.preventDefault();
            var parentElement = '.' + $(this).parent().attr('class');

            $(this).toggleClass('socials__logo--black');

            if ($(this).hasClass('socials__media')) {
                $('.socials__menu').toggleClass('socials__menu--active');
            }

            if ($(this).hasClass('socials__map-icon')) {
                $('.socials__map').toggleClass('socials__map--active');
                $('.socials__menu').removeClass('socials__menu--active');
                $(parentElement + ' .socials__media').removeClass('socials__logo--black');
            }
        })

        _body.on('click', '.map__close', function (e) {
            e.preventDefault();

            $('.socials__map-icon').toggleClass('socials__logo--black');
            $('.socials__map').toggleClass('socials__map--active');
        })
    };

    function _initResizeHeader() {
        if (_window.scrollTop() > 50) {
            _body.addClass('is-sticky');
        } else {
            _body.removeClass('is-sticky');
        }
    }

    function _initRelatedProducts() {
        let sliderRelated = $('.related ul');

        let options = {
            loop: true,
            slideBy: 'page',
            container: '.related ul',
            items: 1,
            autoplay: true,
            autoplayTimeout: 4000,
            speed: 600,
            nav: false,
            autoplayButtonOutput:false,
            controlsText: ["<svg width=\"14\" height=\"24\" viewBox=\"0 0 14 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"> <path d=\"M0.955086 12.4793L11.8417 23.2308C12.2002 23.5813 12.7746 23.5813 13.133 23.2308C13.4869 22.8757 13.4869 22.3068 13.133 21.9517L2.89437 11.842L13.1285 1.73231C13.4869 1.38182 13.4869 0.808281 13.1285 0.453236C12.9492 0.275711 12.7149 0.189226 12.4805 0.189226C12.2461 0.189226 12.0164 0.275711 11.8371 0.453235L0.955086 11.2047C0.785054 11.3732 0.68855 11.6053 0.68855 11.842C0.68855 12.0833 0.785054 12.3108 0.955086 12.4793Z\" fill=\"white\"/> </svg>",
                "<svg width=\"14\" height=\"24\" viewBox=\"0 0 14 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"> <path d=\"M13.0449 11.5207L2.15827 0.769218C1.79983 0.418724 1.2254 0.418724 0.86695 0.769218C0.5131 1.12426 0.5131 1.69325 0.86695 2.04829L11.1056 12.158L0.871545 22.2677C0.513099 22.6182 0.513099 23.1917 0.871545 23.5468C1.05077 23.7243 1.28514 23.8108 1.51951 23.8108C1.75387 23.8108 1.98365 23.7243 2.16287 23.5468L13.0449 12.7953C13.2149 12.6268 13.3115 12.3947 13.3115 12.158C13.3115 11.9167 13.2149 11.6891 13.0449 11.5207Z\" fill=\"white\"/> </svg>"],
            responsive: {
                767: {
                    items: 2
                },
                1170: {
                    items: 3
                }
            }
        };

        if (sliderRelated.length > 0) {
            tns(options);
        }
    }

    function _initProductCategoriesIcon() {

        $('.product-list__category-list--sub li.product-list__category-item--active').parents('ul.product-list__category-list--sub').addClass('sub-is-active').prev().addClass('is-open');

        $(document).on('click', '.product-list__category-item--icon', function(){
            $(this).toggleClass('is-open');
            if($(this).hasClass('is-open')) {
                $(this).next('.product-list__category-list--sub').slideDown();
            }
            else {
                $(this).next('.product-list__category-list--sub').slideUp();
            }
        });
    }

    return {
        init: init,
    };
})(jQuery);

jQuery('document').ready(function () {
    GeneralApp.init();
});
